<template>
  <div class="login-container">
    <div class="login-title" v-fade-down>登录</div>

    <div class="input-group" v-motion="{ initial: { opacity: 0, y: 24 }, animate: { opacity: 1, y: 0 }, transition: { duration: 0.4, delay: 0.1 } }">
      <div class="input-label">用户名</div>
      <input
        type="text"
        autocorrect="off"
        autocapitalize="off"
        v-model="form.account"
      />
    </div>

    <div class="input-group" v-motion="{ initial: { opacity: 0, y: 24 }, animate: { opacity: 1, y: 0 }, transition: { duration: 0.4, delay: 0.2 } }">
      <div class="input-label">密码</div>
      <input
        type="password"
        v-model="form.password"
      />
    </div>

    <button class="login-btn" v-motion="{ initial: { opacity: 0, y: 24 }, animate: { opacity: 1, y: 0 }, transition: { duration: 0.4, delay: 0.3 } }" @click="handleLogin">确定</button>
  </div>
</template>

<script>
import { reactive } from 'vue'
import { login } from '@/api/auth.js'

export default {
  name: 'LoginPage',
  setup() {
    const form = reactive({
      account: '',
      password: ''
    })

    const handleLogin = async () => {
      if (!form.account || !form.password) {
        window.alert('请输入账号和密码')
        return
      }

      try {
        const res = await login(form.account, form.password)

        if (!res || typeof res.code === 'undefined') {
          window.alert('登录返回格式异常')
          return
        }

        if (res.code !== 0) {
          window.alert(res.msg || '登录失败')
          return
        }

        const data = res.data || {}

        if (data.token) {
          try {
            localStorage.setItem('token', data.token)
          } catch (e) {
            console.warn('保存token失败', e)
          }
        }

        try {
          localStorage.setItem('user', JSON.stringify(data))
          // 保存用户名用于后续需要时建立WebSocket连接
          if (data.account) {
            localStorage.setItem('username', data.account)
          }
        } catch (e) {
          console.warn('保存用户信息失败', e)
        }

        // 不在登录时建立 WebSocket 连接，等到真正需要聊天时再连接
        console.log('登录成功，WebSocket 将在需要时自动连接')

        // 跳转到首页
        window.location.href = '/'
      } catch (e) {
        console.error('登录接口异常', e)
        window.alert('登录失败，请稍后重试')
      }
    }

    return {
      form,
      handleLogin
    }
  }
}
</script>

<style scoped>
.login-container {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #ffffff;
  padding: 60px 24px 20px;
  box-sizing: border-box;
}

.login-title {
  font-size: 22px;
  font-weight: 600;
  margin-bottom: 50px;
  color: #1a73e8;
  text-align: center;
}

.input-group {
  width: 100%;
  max-width: 340px;
  margin-bottom: 28px;
}

.input-label {
  font-size: 15px;
  color: #333;
  margin-bottom: 10px;
  text-align: left;
}

.input-group input {
  width: 100%;
  height: 48px;
  border-radius: 8px;
  padding: 0 14px;
  box-sizing: border-box;
  font-size: 16px;
  background-color: #f5f5f5;
  border: none;
  outline: none;
}

.input-group input:focus {
  background-color: #ebebeb;
}

.login-btn {
  width: 100%;
  max-width: 340px;
  height: 50px;
  margin-top: 30px;
  background-color: #4285f4;
  color: #ffffff;
  border-radius: 10px;
  font-size: 17px;
  font-weight: 500;
  border: none;
  cursor: pointer;
}

.login-btn:active {
  background-color: #3367d6;
}
</style>
